import { modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
export const PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER = 'PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER'
export const PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS = 'PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS'
export const PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS = 'STOP_EDITING_CONTACT_NUMBER'
export const PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS = 'PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS'
export const PENDING_APPROVAL_SET_CONTACT_NUMBER = 'PENDING_APPROVAL_SET_CONTACT_NUMBER'
export const PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL = 'PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL'
export const PENDING_APPROVAL_DELETE_CONTACT_NUMBER = 'PENDING_APPROVAL_DELETE_CONTACT_NUMBER'
export const PENDING_APPROVAL_DELETED_CONTACT_NUMBER = 'PENDING_APPROVAL_DELETED_CONTACT_NUMBER'
export const PENDING_APPROVAL_DELETING_CONTACT_NUMBER = 'PENDING_APPROVAL_DELETING_CONTACT_NUMBER'
export const PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER = 'PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER'
export const PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS = 'PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS'
export const PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS = 'PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS'
export const PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS = 'PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS'
export const PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS = 'PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS'

export const addNewContactNumber = (contactNumberType) => ({
  type: PENDING_APPROVAL_ADVISER_CONTACT_NUMBERS_ADD_NEW_NUMBER,
  contactNumber: {
    contactNumberTypeId: contactNumberType.contactNumberTypeId,
    contactNumberType: contactNumberType.contactNumberType,
    contactNumber: '',
    modificationState: modificationStates.added
  }
})

export const startEditingAdviserProfileContactNumbers = (index) => ({
  type: PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS,
  index
})

export const stopEditingAdviserProfileContactNumbers = () => ({
  type: PENDING_APPROVAL_STOP_EDITING_CONTACT_NUMBERS
})

export const cancelEditingAdviserProfileContactNumbers = () => ({
  type: PENDING_APPROVAL_CANCEL_EDITING_CONTACT_NUMBERS
})

export const setContactNumber = (validationResult, contactNumber) => ({
  type: PENDING_APPROVAL_SET_CONTACT_NUMBER,
  validationResult: validationResult,
  contactNumber
})

export const showDeleteContactNumberModal = (index) => ({
  type: PENDING_APPROVAL_DELETE_CONTACT_NUMBER_MODAL,
  index
})

const deleteContactNumber = () => ({
  type: PENDING_APPROVAL_DELETE_CONTACT_NUMBER
})

export const cancelDeletingContactNumber = () => ({
  type: PENDING_APPROVAL_CANCEL_DELETING_CONTACT_NUMBER
})

export const setContactNumberDeleted = () => ({
  type: PENDING_APPROVAL_DELETED_CONTACT_NUMBER
})

export const setContactNumberDeleting = () => ({
  type: PENDING_APPROVAL_DELETING_CONTACT_NUMBER
})

export const deleteContactNumberWrapper = (index) => {
  return (dispatch) => {
    dispatch(deleteContactNumber(index))
    dispatch(setContactNumberDeleting())
  }
}

export const setPublicContactEmailAddress = (validationResult, email) => ({
  type: PENDING_APPROVAL_SET_PUBLIC_CONTACT_EMAIL_ADDRESS,
  validationResult: validationResult,
  publicContactEmailAddress: email
})

export const startEditingPublicContactEmailAddress = () => ({
  type: PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
})

export const stopEditingPublicContactEmailAddress = () => ({
  type: PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
})

export const cancelEditingPublicContactEmailAddress = () => ({
  type: PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS
})
